import styled from 'styled-components';

export const FormContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;

export const SelectorsBar = styled.div`
  width: 100%;
  height: 64px;
  min-height: 64px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 24px;
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  padding: 0 24px 24px 24px;

  display: flex;
  column-gap: 24px;
`;

export const TableCard = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
`;
